export enum SearchColumns {
  id,
  patient,
  physician,
  territory,
  phase,
  status,
  subStatus,
}
